module.exports = __webpack_public_path__ + "r-v3/img/test_user.05b57fe7.svg";